<style type="text/css" media="print">
  @page { size: portrait; }
</style>

<div class="modal-header">
  <button type="button" class="close" ng-click="closeModalImpressao()">×</button>
  <h4 class="modal-title">Parâmetros para Impressão</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xs-12">
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="recommendationSelected[0].quebrarGleba"> Quebrar por Talhão
        </label>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="recommendationSelected[0].exibirTanqueParcial"> Exibir quantidade para tanque parcial
        </label>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-disabled="recommendationSelected[0].tipo_relatorio==='impressao-controle-estoque'" ng-model="recommendationSelected[0].exibirCarencia"> Exibir prazo de carência dos produtos
        </label>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="checkbox">
        <label>
          <input type="checkbox" ng-model="recommendationSelected[0].exibirInformacoes"> Exibir informações adicionais
        </label>
      </div>
    </div>

    <div class="col-xs-12">
      <div class="form-group">
        <label>Capacidade do Tanque</label>
        <input class="form-control" ng-model="recommendationSelected[0].capacidadeTanque" ng-change="changeCapacidadeTanque()"
               type="number" auto-step ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/">
      </div>
    </div>

    <div class="col-xs-12">
      <label for="impressao" class="control-label">Impressão</label>
        <select class="form-control" ng-model="recommendationSelected[0].tipo_relatorio">
          <option value="print-recomendacao">Padrão</option>
          <option value="impressao-controle-estoque">Controle de Estoque</option>
        </select>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" ng-disabled="!recommendationSelected[0].tipo_relatorio" ng-print print-element-id="{{recommendationSelected[0].tipo_relatorio}}">Imprimir</button>
  <button type="button" class="btn btn-default" ng-click="closeModalImpressao()">Cancelar</button>
</div>

<div id="print-recomendacao" class="only-print">
  <div ng-repeat="recommendationSelectedItem in recommendationSelected" class="page-break">
    <div class="pendente-aprovacao-background" ng-if="recommendationSelected[0].situacao === 'aguardando_aprovacao' ">
      <svg width="100%" height="100%" style="transform:rotate(-45deg);" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 400">
        <text x="25%" y="45%" style="fill: #cfcfcf73;">Pendente para aprovação</text>
      </svg>
    </div>
    <img ng-src="{{$root.parametros.imagem_report_url}}" ng-if="$root.parametros.imagem_report_url" class="logo">
    <div class="title-recomendacoes">
      Recomendação de Defensivos #{{recommendationSelectedItem.id}}
    </div>
    <br>
    <div ng-repeat="gleba in ::recommendationSelectedItem.glebas" ng-show="recommendationSelected[0].quebrarGleba" class="page-break">
      <ng-include src="'cabecalho.html'"></ng-include>

      <strong>Propriedade: </strong>{{::recommendationSelectedItem.propriedade.descricao | uppercase}}
      <br>
      <strong>Talhão: </strong>{{::gleba.descricao | uppercase}} ({{::gleba.area_total | number:2}} ha)
      <span class="side-space"></span>
      <strong>Cultura: </strong>{{::recommendationSelectedItem.atividade.descricao | uppercase}}
      </span>
      <br>
      <span ng-show="recommendationSelected[0].exibirInformacoes" ng-repeat="glebaCultivar in recommendationSelectedItem.glebas track by $index">
        <span ng-repeat="infoGleba in glebaCultivar.infoGleba">
          <br>
          <strong>Cultivar: </strong> {{infoGleba.cultivar || 'n/a'}}<br>
          <strong>Data emergência: </strong>{{(infoGleba.data_emergencia | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data de plantio: </strong>{{(infoGleba.data_inicio_plantio | date: 'dd/MM/yy') || 'n/a'}} a {{(infoGleba.data_fim_plantio | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data estimada colheita: </strong>{{(infoGleba.data_estimada_colheita | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Dias do ciclo até hoje: </strong>{{infoGleba.dias_ciclo || 'n/a'}}<br>
        </span>
      </span>

      <ng-include src="'produtos.html'"></ng-include>
      <ng-include src="'mais-detalhes.html'"></ng-include>

      <div class="signatures">
        <print-signature label="Recomendante" name="recommendationSelectedItem.recomendante.nome_completo"></print-signature>
        <print-signature label="Responsável" name="recommendationSelectedItem.responsavel.nome_completo"></print-signature>
      </div>
    </div>

    <div ng-hide="recommendationSelected[0].quebrarGleba">
      <ng-include src="'cabecalho.html'"></ng-include>

      <strong>Propriedade: </strong>{{::recommendationSelectedItem.propriedade.descricao | uppercase}}
      <br>
      <strong>Talhões: </strong>
      <span ng-repeat="gleba in recommendationSelectedItem.glebas track by $index">
        <span ng-show="$index > 0">, </span>
        {{::gleba.descricao | uppercase}} ({{::gleba.area_total || 0 | number:2}} ha)
      </span>
      <span class="side-space"></span>
      <strong>Cultura: </strong>{{::recommendationSelectedItem.atividade.descricao | uppercase }}
      <br>
      <strong>Safra: </strong>{{::recommendationSelectedItem.safra.descricao}}
      <br>
      <span ng-show="recommendationSelected[0].exibirInformacoes" ng-repeat="glebaCultivar in recommendationSelectedItem.glebas track by $index">
        <span ng-repeat="infoGleba in glebaCultivar.infoGleba">
          <br>
          <strong>Cultivar: </strong> {{infoGleba.cultivar || 'n/a'}}<br>
          <strong>Data emergência: </strong>{{(infoGleba.data_emergencia | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data de plantio: </strong>{{(infoGleba.data_inicio_plantio | date: 'dd/MM/yy') || 'n/a'}} a {{(infoGleba.data_fim_plantio | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Data estimada colheita: </strong>{{(infoGleba.data_estimada_colheita | date: 'dd/MM/yy') || 'n/a'}}<br>
          <strong>Dias do ciclo até hoje: </strong>{{infoGleba.dias_ciclo || 'n/a'}}<br>
        </span>
      </span>
      <br>
      <ng-include src="'produtos.html'"></ng-include>
      <ng-include src="'mais-detalhes.html'"></ng-include>

      <div class="signatures">
        <print-signature label="Recomendante" name="recommendationSelectedItem.recomendante.nome_completo"></print-signature>
        <print-signature label="Responsável" name="recommendationSelectedItem.responsavel.nome_completo"></print-signature>
      </div>
    </div>
  </div>
</div>

<div id="impressao-controle-estoque" class="only-print small" >
  <ng-include src="'views/_modal_impressao_v2.html'"></ng-include>
</div>

<script type="text/ng-template" id="cabecalho.html">
  <p>
    <strong>Previsto: </strong>
    {{::recommendationSelectedItem.data_inicio | date:'dd/MM/yyyy'}}  até {{::recommendationSelectedItem.data_termino | date:'dd/MM/yyyy'}}
    <br>
    <strong>Recomendante: </strong>
    {{::recommendationSelectedItem.recomendante.nome_completo | capitalize}}
  </p>
</script>

<script type="text/ng-template" id="produtos.html">
  <table class="table no-padding recomendacao">
    <thead>
      <tr>
        <th class="no-padding-left">Produto</th>
        <th class="text-right">Dose</th>
        <th class="text-right" ng-show="recommendationSelectedItem.capacidadeTanque && (gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) >= 1">Tanque Cheio</th>
        <th class="text-right" ng-show="recommendationSelected[0].exibirTanqueParcial && recommendationSelectedItem.capacidadeTanque && getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) > 0">Tanque Parcial ({{getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) | number:2}}) / Água: {{getWaterApplication(recommendationSelectedItem.capacidadeTanque, getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas)) | number:0}} l</th>
        <th class="text-right">Total</th>
        <th class="text-right" ng-show="recommendationSelected[0].exibirCarencia">Prazo Carência</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="produto in ::recommendationSelectedItem.insumos track by $index">
        <td class="no-padding-left vertical-middle">{{::produto.descricao}}</td>
        <td class="text-right">{{produto.dose | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}/ha</td>
        <td class="text-right" ng-show="recommendationSelectedItem.capacidadeTanque && (gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) >= 1">{{produto.capacidade.totalTanque | formatDynamicDecimals}} {{produto.capacidade.abreviatura}}</td>
        <td class="text-right" ng-show="recommendationSelected[0].exibirTanqueParcial && recommendationSelectedItem.capacidadeTanque && getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) > 0">{{getTotalParcial(gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas) *  produto.capacidade.totalTanque | formatDynamicDecimals}} {{produto.capacidade.abreviatura}}</td>
        <td class="text-right">{{calculateTotalProduto(produto, gleba.area_total || recommendationSelectedItem.area_total_recomendada, !!recommendationSelected[0].quebrarGleba && recommendationSelectedItem.glebas.length > 1) | formatDynamicDecimals}} {{::produto.unidade.abreviatura}}</td>
        <td class="text-right" ng-if="recommendationSelected[0].exibirCarencia && produto.carencia_residual_dias">{{produto.carencia_residual_dias}} dias</td>
        <td class="text-right" ng-if="recommendationSelected[0].exibirCarencia && !produto.carencia_residual_dias"></td>
      </tr>
    </tbody>
  </table>
</script>

<script type="text/ng-template" id="mais-detalhes.html">
  <span ng-show="recommendationSelectedItem.glebas.length > 1 && !gleba.numeroAbastecidas && recommendationSelectedItem.capacidadeTanque">
    <p class="list-group-item-text">
      <strong>Área Total: </strong>{{recommendationSelectedItem.areaTotal | number:2}} ha
    </p>
  </span>

  <span ng-show="recommendationSelectedItem.capacidadeTanque">
    <p class="list-group-item-text">
      <strong>Capacidade Tanque: </strong>{{recommendationSelectedItem.capacidadeTanque | number:2}} l
    </p>
    <p class="list-group-item-text">
      <strong>Nº de abastecidas: </strong>{{gleba.numeroAbastecidas || recommendationSelectedItem.totalAbastecidas | number:2}}
    </p>
  </span>
  <p class="list-group-item-text"><strong>Vazão: </strong>{{::recommendationSelectedItem.vazao | number:2}} l/ha</p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.bico">
    <strong>Bico: </strong>{{::recommendationSelectedItem.bico}}
  </p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.pressao.valor">
    <strong>Pressão: </strong>{{::recommendationSelectedItem.pressao.valor | number:0}} {{::recommendationSelectedItem.pressao.unidade}}
  </p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.velocidade.minima || recommendationSelectedItem.velocidade.maxima">
    <strong>Velocidade: </strong>{{::recommendationSelectedItem.velocidade.minima | number:0}}km/h à {{::recommendationSelectedItem.velocidade.maxima | number:0}} km/h
  </p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.vento.maxima">
    <strong>Vento: </strong>{{::recommendationSelectedItem.vento.maxima | number:0}} km/h
  </p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.umidade.minima || recommendationSelectedItem.umidade.maxima">
    Umidade
    <span ng-show="recommendationSelectedItem.umidade.minima">
      acima de <strong>{{::recommendationSelectedItem.umidade.minima | number:0}}%</strong>
    </span>
    <span ng-show="recommendationSelectedItem.umidade.maxima">
      abaixo de <strong>{{::recommendationSelectedItem.umidade.maxima | number:0}}%</strong>
    </span>
  </p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.temperatura.minima || recommendationSelectedItem.temperatura.maxima">
    Temperatura
    <span ng-show="recommendationSelectedItem.temperatura.minima">
      acima de <strong>{{::recommendationSelectedItem.temperatura.minima | number:0}}°C</strong>
    </span>
    <span ng-show="recommendationSelectedItem.temperatura.maxima">
      abaixo de <strong>{{::recommendationSelectedItem.temperatura.maxima | number:0}}°C</strong>
    </span>
  </p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.horas_sem_chuva">
    <strong>{{::recommendationSelectedItem.horas_sem_chuva | number:0}} horas</strong> sem chuva
  </p>
  <p class="list-group-item-text" ng-show="recommendationSelectedItem.observacao">
    <strong>Observação: </strong> {{::recommendationSelectedItem.observacao}}
  </p>
</script>
